<template>
  <div class="child_hobby">
     <div class="child_hobby_content" ref="hobby">
        <div class="child_hobby_content_list">
            <div class="child_hobby_content_box" v-for="(item,index) in dataList" :key="item.code">
               <p class="child_hobby_content_box_caption">
                  <span class="child_hobby_content_box_caption_name">{{item.title}}</span>
                  <span style="display:inline-block;" @click="addHobby(item.title,index,item.type,item.code)"><i class="icon_add" ></i></span>
                  
               </p>
               <div class="child_hobby_content_box_items" >
                  <div class="child_hobby_content_box_items_block"
                  v-for=" (val,ject) in item.hobbyList" :key="val.id"
                  :class="item.hobbyShowList&&item.hobbyShowList[ject] ? 'is_active' : ''">
                     <span class="child_hobby_content_box_items_block_name" @click="choiceHobby(index,ject,val)">{{val.label}}</span>
                     <!-- <i class="icon-del" @click="delChoice(1,index,ject,item.key,val)"></i> -->
                  </div>
               </div>
                <div class="child_hobby_content_box_items">
                   <div class="child_hobby_content_box_items_block custom"
                     v-for="(val,ject) in item.customHobbyList" :key="val.id"
                     :class="item.customHobbyShowList&&item.customHobbyShowList[ject] ? 'is_active' : ''" >
                        <span class="child_hobby_content_box_items_block_name" @click="choiceCustomHobby(index,ject,val)">{{val.label}}</span>
                        <span style="display:inline-block;" @click="delChoice(index,ject,val)"><i class="icon-del"></i></span>
                     </div>
                </div>
            </div>

         </div>
     </div>
     <div class="child_hobby_content_bottom">
         <i class="icon_save" @click="onSave">保存</i>
      </div>
    <!-- 新增自定义标签 -->
    <add-info v-if="infoShow" :infoShow="infoShow" :code="code" :title="title" @close="onClose" @confirm="onConfirm" :type="type" ref="addCustom"></add-info>
    <!--删除自定义标签提示框  -->
    <modal
         btnType='2'
         ref="delModal"
         @submit="onSure"
         @cancel='onCancel'>
         <template v-slot:body>
               <p>是否确定删除此自定义标签?</p>
         </template>
      </modal>
  </div>
</template>

<script>
import addInfo from '../../components/children-file/add-info.vue';
import { _saveFavoriteLabel,_getList,_delFavoriteLabel,_saveSingleFavoriteLabel } from '../../api/children-file';
import Modal from '../common/modal.vue';
import BScroll from "better-scroll";
export default {
   name:'hobby',
   props:{
      componentData:{
         type:Object
      },
      // hobbyList:{
      //    type:Array
      // },
      // studentId:{
      //    type:String
      // },
      // favoriteAndLabelId:{
      //    type:String
      // }
   },
   components:{
      addInfo,
      Modal
   },
   data() {
      return {
         infoShow:false,
         title:"请自定义添加爱好",
         type:"1",
         FIndex:null,
         addType:null, // 新增爱好类别
         dataList:[],
         customId:"",// 删除的自定义标签id
         delFIndex:null,
         delCIndex:null,
         bs:null,
         code:"",

      }
   },
   watch:{
      componentData:{
         handler(data) {
            this.dataList = JSON.parse(JSON.stringify(data.hobbyList));
            this.dataList.map(item=>{
               // 处理默认爱好选中的展示
               item.hobbyList.map((val,index)=>{
                  item.choiceHobby.map(ite => {
                     if(val.label == ite.label){
                        item.hobbyShowList[index] = true;
                     }
                  })
               })
               // 处理自定义爱好选中的展示
               item.customHobbyList.map((val,index) => {
                  item.choiceCustomHobby.map(ite=>{
                     if(val.label == ite.label){
                        item.customHobbyShowList[index] = true;
                     }
                  })
               })
            })
            if(this.bs){
               setTimeout(()=>{
                  this.initSroll()
               },200)
            }

         },
         immediate:true,
         deep:true
      },
   },
   created() {

   },
   mounted() {
      this.$nextTick(()=>{
        setTimeout(()=>{
            this.initSroll()
         },200)
      })
   },
   methods:{
      initSroll(refresh) {
         if(!this.$refs.hobby){
            return;
         }
         this.bs = new BScroll(this.$refs.hobby,{
            pullUpLoad: true, // 不触发上拉事件
            scrollbar: true, // 展示滚动条
            pullDownRefresh: true, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
            scrollX:false, // 关闭横向滚动功能
            scrollY:true,  
            bounce:false, // 关闭滚动到边缘时的回弹动作
            click:true, // 开启点击事件
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
         })
         if(refresh){
            // 让页面回到顶部
             this.bs.scrollTo(0,this.bs.maxScrollY)
         }
      },
       // 勾选默认标签
      choiceHobby(index,ject,item) {
         if(this.dataList[index].hobbyShowList[ject]){
            this.$set(this.dataList[index].hobbyShowList,ject,false);
            this.dataList[index].choiceHobby.splice(ject,1)
         }else{
            this.$set(this.dataList[index].hobbyShowList,ject,true);
            this.dataList[index].choiceHobby.push(item);
         }
      },
      // 勾选自定义标签
      choiceCustomHobby(index,ject,item) {
         if(this.dataList[index].customHobbyShowList[ject]){
            this.$set(this.dataList[index].customHobbyShowList,ject,false);
            this.dataList[index].choiceCustomHobby.splice(ject,1)
         }else{
            this.$set(this.dataList[index].customHobbyShowList,ject,true);
            this.dataList[index].choiceCustomHobby.push(item);
         }

      },
      // 保存删除的爱好
      saveDelFavorite(index,ject,id) {
         _delFavoriteLabel(id).then(res=>{
            if(res.code == 200){
               let dIndex = null;
               this.dataList[index].choiceCustomHobby.map((val,index) => {
                  if(val.id == id){
                     dIndex = index;
                  }
               })
               this.dataList[index].customHobbyShowList.splice(ject,1);
               this.dataList[index].customHobbyList.splice(ject,1);
               this.dataList[index].choiceCustomHobby.splice(dIndex,1);
               Toast({message:'删除成功',className:'rotation'});
               this.onCancel();
               this.$emit('delHobby',this.dataList)
               setTimeout(()=>{
                  this.initSroll('refresh')
               },200)
            }else{
               Toast({message:res.message,className:'rotation'});
               this.onCancel();
            }
         })
      },
      // 删除自定义标签
      delChoice(index,ject,item) {
         this.$refs.delModal.openDialog();
         this.customId = item.id;
         this.delFIndex = index;
         this.delCIndex = ject;
         // this.$dialog.confirm({
         //    title: '提示',
         //    message: '是否确定删除此自定义标签',
         //    className:'rotation'
         // })
         // .then(() => {
         //    this.saveDelFavorite(index,ject,item)
         // })
         // .catch(() => {
         //    // on cancel
         // });
      },
      // 确定删除标签
      onSure() {
         this.saveDelFavorite(this.delFIndex,this.delCIndex,this.customId)
      },
      // 关闭删除标签弹窗
      onCancel() {
         this.$refs.delModal.closeDialog()
      },
      // 保存爱好
      onSave() {
        let params = [];
        this.dataList.map(item=>{
           item.hobbyList.map(val=>{
              let obj = {
                  id:val.id,
                  studentId:val.studentId,
                  type:val.type,
                  label:val.label,
                  checkEnable:false,
                  customEnable:false,
                  sort:val.sort
               }
               item.choiceHobby.map(ite => {
                  if(val.label == ite.label){
                     obj.checkEnable = true
                  }
               })
              params.push(obj)
           })
           item.customHobbyList.map(val => {
              let obj = {
                  id:val.id,
                  studentId:val.studentId,
                  type:val.type,
                  label:val.label,
                  checkEnable:false,
                  customEnable:true,
                  sort:val.sort
               }
               item.choiceCustomHobby.map(ite => {
                  if(val.label == ite.label){
                     obj.checkEnable = true
                  }
               })
               params.push(obj)
           })

        })
         _saveFavoriteLabel(params).then(res=>{
            if(res.code == 200){
               this.$emit('saveHobby',this.dataList)
               Toast({message:"新增爱好成功",className:'rotation'})
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      // 打开新增自定义爱好的弹窗
      addHobby(title,index,type,code) {
         // 解决better-scroll中transform层级过高带来的影响
         document.getElementsByClassName('child_hobby_content')[0].style.transform = 'translateZ(-1px)';
         document.getElementsByClassName('bscroll-indicator')[0].style.transform = 'translateZ(-1px)';
         this.infoShow = true;
         this.title = "请自定添加"+title;
         this.FIndex = index;
         this.addType = type;
         this.code = code;
         
      },
      // 关闭新增自定义爱好的弹窗
      onClose() {
         this.infoShow = false
      },
      // 保存爱好
      onConfirm(name) {
         let dataList = this.dataList[this.FIndex].customHobbyList.concat(this.dataList[this.FIndex].hobbyList)
         if( this.dataList[this.FIndex].customHobbyList.length < 4){
            // 判断新增的爱好与现有的是否重名
            if(dataList.indexOf(name) == -1){
               let params = {
                     id:'',
                     studentId:this.componentData.studentId,
                     type:this.addType,
                     label:name,
                     checkEnable:false,
                     customEnable:true,
                  }
                _saveSingleFavoriteLabel(params).then(res=>{
                  if(res.code == 200){
                     Toast({message:"新增自定义标签成功",className:'rotation'})
                     this.dataList[this.FIndex].customHobbyList.push({
                        id:res.data,
                        label:name,
                        type:this.addType,
                        sort:'',
                        studentId:this.componentData.studentId
                     })
                     this.dataList[this.FIndex].customHobbyShowList.push(false);
                     this.$emit('addHobby',this.dataList)
                     setTimeout(()=>{
                        this.initSroll('refresh')
                     },200)
                  }else{
                     Toast({message:res.message,className:'rotation'})
                  }
               })
            }else{
               Toast({message:'请不要重复添加自定义标签哦~',className:'rotation'})
               return;
            }
         }else{
            Toast({message:'最多只能添加4个自定爱好标签哦~',className:'rotation'})
         }
          this.infoShow = false;

      },
   }
}
</script>

<style lang="scss" scoped>
.child_hobby{
   width:100%;
   height:100%;
   padding:45px 68px 77px;
   position:relative;
   .child_hobby_content{
      width:100%;
      height:100%;
      overflow: hidden;
      position: relative;
      ::v-deep .bscroll-vertical-scrollbar{
            background-color: #D39B5A;
            border-radius: 4px;
            width: 8px;
            overflow:visible !important;
            opacity: 1 !important;
            z-index:80 !important;
            .bscroll-indicator{
               background-color: #FF8000 !important;
               border-radius: 4px !important;
               border-color:#FF8000 !important;
               // height:65px !important;
            }
         }
         ::v-deep .bscroll-indicator{
            background-color: #FF8000;
            border-radius: 4px;
         }
   }
   .child_hobby_content_list{
      // height:100%;
      // height:calc(100% - 77px);
      overflow-y:auto;
      overflow-x:hidden;
      white-space: nowrap;
      /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/

         &::-webkit-scrollbar {
            width: 8px; /*对垂直流动条有效*/
            border-radius: 4px;
            height:100px;
            // height: 20px; /*对水平流动条有效*/
         }

         /*定义滚动条的轨道颜色、内阴影及圆角*/
         &::-webkit-scrollbar-track{
            // box-shadow: 0 0 3px 0 rgba(0,0,0,0.5), 1px 0 3px 0 #8E6138;
            background-color: #D39B5A;
            border-radius: 4px;
         }
           &::-webkit-scrollbar-track-piece{
            border-radius:4px;
         }
         /*定义滑块颜色、内阴影及圆角*/
         &::-webkit-scrollbar-thumb{
            // box-shadow: 0 0 4px 0 rgba(255,255,255,0.5),-2px 0 0 0 rgba(196,106,47,0.5);
            background-color: #FF8000;
            border-radius: 4px;
         }

   }
   .child_hobby_content_box{
      margin-bottom:8px;
      .child_hobby_content_box_caption{
         color:#74410A;
         font-size:12px;
         font-weight:400;
         font-family: PingFangSC-Regular, PingFang SC;
         .child_hobby_content_box_caption_name{
            display: inline-block;
            height:17px;
            line-height:17px;
            vertical-align: middle;
            margin-right:6px;
         }
         .icon_add{
            display: inline-block;
            width:14px;
            height:14px;
            background:url('../../assets/images/children-file/add.png') no-repeat;
            background-size:100% 100%;
            vertical-align: middle;
            cursor:pointer;
         }
      }
      .child_hobby_content_box_items{
         margin-top:8px;
         width:100%;
         // display: flex;
         .child_hobby_content_box_items_block{
            width:auto;
            position: relative;
            box-sizing: border-box;
            margin-right:20px;
            display:inline-block;
            margin-bottom:8px;
            .child_hobby_content_box_items_block_name{
               display:inline-block;
               width:100%;
               height:100%;
               padding:4px 10px;
               border:1px solid #BE8E56;
               border-radius:6px;
               height:24px;
               line-height:14px;
               // height:17px;
               color:#CF995C;
               // line-height:17px;
               vertical-align: top;
               font-size:12px;
            }
            .icon-del{
               // display: none;
               width:10px;
               height:10px;
               background: url('../../assets/images/children-file/del.png') no-repeat;
               background-size:100% 100%;
               position:absolute;
               top:-5px;
               right:-5px;
            }
            &.is_active{
               .child_hobby_content_box_items_block_name{
                  border-color:#F4DA8F;
                  background: #F4DA8F;
                  color:#96652C;
               }
               // .icon-del{
               //    display: inline-block;
               // }
            }
         }
      }
   }
   .child_hobby_content_bottom{
      position: absolute;
      right:93px;
      bottom:32px;
      // height:47px;
      // position: relative;
      .icon_save{
      //    position: absolute;
      // right:93px;
      // bottom:32px;
         display: block;
         width:96px;
         height:47px;
         background: url('../../assets/images/children-file/btn1.png') no-repeat;
         background-size:100% 100%;
         text-align: center;
         line-height:42px;
         color:#74410A;
         font-size:12px;
         font-style: normal;
         font-weight:400;
         font-family: PingFangSC-Regular, PingFang SC;
      }
   }

}
</style>
